import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=564d0302&scoped=true&"
import script from "./reset-password.vue?vue&type=script&lang=js&"
export * from "./reset-password.vue?vue&type=script&lang=js&"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=564d0302&prod&lang=scss&"
import style1 from "./reset-password.vue?vue&type=style&index=1&id=564d0302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d0302",
  null
  
)

export default component.exports